import { styled } from '@mui/material/styles';
import { Box, Paper, Accordion } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4, 2),
  maxWidth: 1200,
  margin: '0 auto',
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(5, 3),
  },
}));

export const PageHeader = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(6),
  '& h1': {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    background: 'linear-gradient(45deg, #FFA000, #FF6D00)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  '& p': {
    fontSize: '1.125rem',
    color: theme.palette.text.secondary,
  },
}));

export const ContactDetailsSection = styled(Box)(() => ({
}));

export const ContactInfoCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
  height: 'calc(100% - 60px)', // Account for title
}));

export const ContactInfoItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
  '& svg': {
    fontSize: 24,
    marginTop: 4,
  },
  '& a': {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    transition: 'color 0.2s',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

export const ContactFormContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
  boxShadow: 'none',
}));

export const FAQSection = styled(Box)(({ theme }) => ({

  marginBottom: theme.spacing(5),
  padding: theme.spacing(4),
  borderRadius: 12,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
}));

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 8,
  marginBottom: theme.spacing(2),
  '&:before': {
    display: 'none',
  },
  '& .MuiAccordionSummary-root': {
    padding: theme.spacing(2, 3),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  '& .MuiAccordionDetails-root': {
    padding: theme.spacing(2, 3, 3),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  '&.Mui-expanded': {
    margin: `0 0 ${theme.spacing(2)}px`,
    '&:last-child': {
      marginBottom: 0,
    },
  },
}));